import { OFFER_TYPES } from "../constants/offerTypes";
import {
  loadBrandPhoneOfferIds,
  loadBrandPropositionIds,
  loadBrands
} from "../actions/portalData/brandData";
import { loadOfferExtraGroups } from "../actions/portalData/offerExtraGroupData";
import {
  loadOfferExtraPhoneOfferIds,
  loadOfferExtraPropositionIds,
  loadOfferExtras,
  loadOfferExtraSimOnlyIds
} from "../actions/portalData/offerExtraData";
import {
  loadPhoneOperatingSystemPhoneOfferIds,
  loadPhoneOperatingSystemPropositionIds,
  loadPhoneOperatingSystems
} from "../actions/portalData/phoneOperatingSystemData";
import { loadPhoneStates } from "../actions/portalData/phoneStateData";
import {
  loadPhoneVariantPhoneOfferIds,
  loadPhoneVariantPropositionIds,
  loadPhoneVariants
} from "../actions/portalData/phoneVariantData";
import {
  loadPhonePhoneOfferIds,
  loadPhonePhoneOfferPopularIds,
  loadPhonePropositionIds,
  loadPhonePropositionPopularIds,
  loadPhones
} from "../actions/portalData/phoneData";
import {
  loadProviderPropositionIds,
  loadProviderSimOnlyIds,
  loadProviders
} from "../actions/portalData/providerData";
import {
  loadShopPhoneOfferIds,
  loadShopPropositionIds,
  loadShops,
  loadShopSimOnlyIds
} from "../actions/portalData/shopData";
import {
  loadPhoneOfferCount,
  loadPropositionCount,
  loadSimOnlyCount
} from "../actions/portalData/offerTypeCounts";
import {
  loadDataSpeedGenPropositionIds,
  loadDataSpeedGens,
  loadDataSpeedGenSimOnlyIds
} from "../actions/portalData/dataSpeedGenData";
import { loadPhoneCategories } from "../actions/portalData/phoneCategoryData";
import { WIDGETS } from "../constants/widgets";

function entitiesDataStatus(portalData, type) {
  try {
    return {
      didInvalidate:
        portalData.status[type].didInvalidate ||
        portalData.entities[type].allIds.length === 0,
      isFetching: portalData.status[type].isFetching,
      lastUpdated: portalData.status[type].lastUpdated,
      startFetching: portalData.status[type].startFetching
    };
  } catch (e) {
    return {
      didInvalidate: true,
      isFetching: false,
      lastUpdated: 0,
      startFetching: 0
    };
  }
}

function idsDataStatus(portalData, type, offerType) {
  const idKey = offerType + "Ids";

  try {
    return {
      didInvalidate:
        portalData.status[type].didInvalidate ||
        portalData.entities[type][idKey].length === 0,
      lastUpdated: portalData.status[type].lastUpdated
    };
  } catch (e) {
    return {
      didInvalidate: true,
      lastUpdated: 0
    };
  }
}

function offerTypeCountStatus(portalData, offerType) {
  try {
    return {
      didInvalidate:
        portalData.status.offerTypeCounts[offerType].didInvalidate ||
        portalData.offerTypeCounts[offerType] == null,
      lastUpdated: portalData.status.offerTypeCounts[offerType].lastUpdated
    };
  } catch (e) {
    return {
      didInvalidate: true,
      lastUpdated: 0
    };
  }
}

function loadBrandData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer) {
    dispatch(
      loadBrandPhoneOfferIds(
        clientConfig,
        idsDataStatus(portalData, "brands", OFFER_TYPES.phoneOffer)
      )
    );
  }

  if (pDConfig.proposition) {
    dispatch(
      loadBrandPropositionIds(
        clientConfig,
        idsDataStatus(portalData, "brands", OFFER_TYPES.proposition)
      )
    );
  }

  if (pDConfig.phoneOffer || pDConfig.proposition) {
    dispatch(
      loadBrands(clientConfig, entitiesDataStatus(portalData, "brands"))
    );
  }
}

function loadDataSpeedGenData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.proposition) {
    dispatch(
      loadDataSpeedGenPropositionIds(
        clientConfig,
        idsDataStatus(portalData, "dataSpeedGens", OFFER_TYPES.proposition)
      )
    );
  }

  if (pDConfig.simOnly) {
    dispatch(
      loadDataSpeedGenSimOnlyIds(
        clientConfig,
        idsDataStatus(portalData, "dataSpeedGens", OFFER_TYPES.simOnly)
      )
    );
  }

  if (pDConfig.proposition || pDConfig.simOnly) {
    dispatch(
      loadDataSpeedGens(
        clientConfig,
        entitiesDataStatus(portalData, "dataSpeedGens")
      )
    );
  }
}

function loadOfferExtraData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer) {
    dispatch(
      loadOfferExtraPhoneOfferIds(
        clientConfig,
        idsDataStatus(portalData, "offerExtras", OFFER_TYPES.phoneOffer)
      )
    );
  }

  if (pDConfig.proposition) {
    dispatch(
      loadOfferExtraPropositionIds(
        clientConfig,
        idsDataStatus(portalData, "offerExtras", OFFER_TYPES.proposition)
      )
    );
  }

  if (pDConfig.simOnly) {
    dispatch(
      loadOfferExtraSimOnlyIds(
        clientConfig,
        idsDataStatus(portalData, "offerExtras", OFFER_TYPES.simOnly)
      )
    );
  }

  if (pDConfig.phoneOffer || pDConfig.proposition || pDConfig.simOnly) {
    dispatch(
      loadOfferExtras(
        clientConfig,
        entitiesDataStatus(portalData, "offerExtras")
      )
    );
  }
}

function loadOfferExtraGroupData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer || pDConfig.proposition || pDConfig.simOnly) {
    dispatch(
      loadOfferExtraGroups(
        clientConfig,
        entitiesDataStatus(portalData, "offerExtraGroups")
      )
    );
  }
}

function loadOfferTypeCounts(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer) {
    dispatch(
      loadPhoneOfferCount(
        clientConfig,
        offerTypeCountStatus(portalData, OFFER_TYPES.phoneOffer)
      )
    );
  }

  if (pDConfig.proposition) {
    dispatch(
      loadPropositionCount(
        clientConfig,
        offerTypeCountStatus(portalData, OFFER_TYPES.proposition)
      )
    );
  }

  if (pDConfig.simOnly) {
    dispatch(
      loadSimOnlyCount(
        clientConfig,
        offerTypeCountStatus(portalData, OFFER_TYPES.simOnly)
      )
    );
  }
}

function loadPhoneCategoryData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer || pDConfig.proposition) {
    dispatch(
      loadPhoneCategories(
        clientConfig,
        entitiesDataStatus(portalData, "phoneCategories")
      )
    );
  }
}

function loadPhoneOperatingSystemData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer) {
    dispatch(
      loadPhoneOperatingSystemPhoneOfferIds(
        clientConfig,
        idsDataStatus(
          portalData,
          "phoneOperatingSystems",
          OFFER_TYPES.phoneOffer
        )
      )
    );
  }

  if (pDConfig.proposition) {
    dispatch(
      loadPhoneOperatingSystemPropositionIds(
        clientConfig,
        idsDataStatus(
          portalData,
          "phoneOperatingSystems",
          OFFER_TYPES.proposition
        )
      )
    );
  }

  if (pDConfig.phoneOffer || pDConfig.proposition) {
    dispatch(
      loadPhoneOperatingSystems(
        clientConfig,
        entitiesDataStatus(portalData, "phoneOperatingSystems")
      )
    );
  }
}

function loadPhoneStateData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer || pDConfig.proposition) {
    dispatch(
      loadPhoneStates(
        clientConfig,
        entitiesDataStatus(portalData, "phoneStates")
      )
    );
  }
}

function loadPhoneVariantData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer) {
    dispatch(
      loadPhoneVariantPhoneOfferIds(
        clientConfig,
        idsDataStatus(portalData, "phoneVariants", OFFER_TYPES.phoneOffer)
      )
    );
  }

  if (pDConfig.proposition) {
    dispatch(
      loadPhoneVariantPropositionIds(
        clientConfig,
        idsDataStatus(portalData, "phoneVariants", OFFER_TYPES.proposition)
      )
    );
  }

  if (pDConfig.phoneOffer || pDConfig.proposition) {
    dispatch(
      loadPhoneVariants(
        clientConfig,
        entitiesDataStatus(portalData, "phoneVariants")
      )
    );
  }
}

function loadPhoneData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer) {
    dispatch(
      loadPhonePhoneOfferIds(
        clientConfig,
        idsDataStatus(portalData, "phones", OFFER_TYPES.phoneOffer)
      )
    );

    dispatch(
      loadPhonePhoneOfferPopularIds(
        clientConfig,
        idsDataStatus(portalData, "phones", OFFER_TYPES.phoneOffer)
      )
    );
  }

  if (pDConfig.proposition) {
    dispatch(
      loadPhonePropositionIds(
        clientConfig,
        idsDataStatus(portalData, "phones", OFFER_TYPES.proposition)
      )
    );

    dispatch(
      loadPhonePropositionPopularIds(
        clientConfig,
        idsDataStatus(portalData, "phones", OFFER_TYPES.proposition)
      )
    );
  }

  if (pDConfig.phoneOffer || pDConfig.proposition) {
    dispatch(
      loadPhones(clientConfig, entitiesDataStatus(portalData, "phones"))
    );
  }
}

function loadProviderData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.proposition) {
    dispatch(
      loadProviderPropositionIds(
        clientConfig,
        idsDataStatus(portalData, "providers", OFFER_TYPES.proposition)
      )
    );
  }

  if (pDConfig.simOnly) {
    dispatch(
      loadProviderSimOnlyIds(
        clientConfig,
        idsDataStatus(portalData, "providers", OFFER_TYPES.simOnly)
      )
    );
  }

  if (pDConfig.proposition || pDConfig.simOnly) {
    dispatch(
      loadProviders(clientConfig, entitiesDataStatus(portalData, "providers"))
    );
  }
}

function loadShopData(dispatch, clientConfig, portalData) {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer) {
    dispatch(
      loadShopPhoneOfferIds(
        clientConfig,
        idsDataStatus(portalData, "shops", OFFER_TYPES.phoneOffer)
      )
    );
  }

  if (pDConfig.proposition) {
    dispatch(
      loadShopPropositionIds(
        clientConfig,
        idsDataStatus(portalData, "shops", OFFER_TYPES.proposition)
      )
    );
  }

  if (pDConfig.simOnly) {
    dispatch(
      loadShopSimOnlyIds(
        clientConfig,
        idsDataStatus(portalData, "shops", OFFER_TYPES.simOnly)
      )
    );
  }

  if (pDConfig.phoneOffer || pDConfig.proposition || pDConfig.simOnly) {
    dispatch(loadShops(clientConfig, entitiesDataStatus(portalData, "shops")));
  }
}

function checkEntityFilter(entity, filter) {
  const filterKeys = Object.keys(filter);

  let matchesFilter = true;

  for (const key of filterKeys) {
    if (filter[key] !== null && typeof filter[key] === "object") {
      matchesFilter = checkEntityFilter(entity[key], filter[key]);
    } else {
      matchesFilter = entity[key] === filter[key];
    }

    if (!matchesFilter) {
      return matchesFilter;
    }
  }

  return matchesFilter;
}

function typesFromType(type) {
  const lastLetter = type.slice(-1);
  let types;

  if (lastLetter === "y") {
    types = `${type.slice(0, -1)}ies`;
  } else {
    types = `${type}s`;
  }

  return types;
}

const loadPortalData = (dispatch, clientConfig, portalData) => {
  const widget = clientConfig.widget;
  const pDConfig = WIDGETS[widget].portalData;

  if (pDConfig.phoneOffer || pDConfig.proposition || pDConfig.simOnly) {
    loadBrandData(dispatch, clientConfig, portalData);
    loadDataSpeedGenData(dispatch, clientConfig, portalData);
    loadOfferExtraData(dispatch, clientConfig, portalData);
    loadOfferExtraGroupData(dispatch, clientConfig, portalData);
    loadOfferTypeCounts(dispatch, clientConfig, portalData);
    loadPhoneCategoryData(dispatch, clientConfig, portalData);
    loadPhoneOperatingSystemData(dispatch, clientConfig, portalData);
    loadPhoneStateData(dispatch, clientConfig, portalData);
    loadPhoneVariantData(dispatch, clientConfig, portalData);
    loadPhoneData(dispatch, clientConfig, portalData);
    loadProviderData(dispatch, clientConfig, portalData);
    loadShopData(dispatch, clientConfig, portalData);
  }
};

const phoneVariantIdsForPhoneId = (portalData, offerType, phoneId) => {
  const phone = findPortalDataEntity(portalData, "phone", phoneId);
  if (phone == null) {
    return [];
  }

  const allPhoneVariantIds = phone.phoneVariants.map(pV => pV.id);
  const offerTypePhoneVariantIds =
    portalData.entities.phoneVariants[`${offerType}Ids`];

  return allPhoneVariantIds.filter(
    pId => offerTypePhoneVariantIds.indexOf(pId) >= 0
  );
};

const filteredEntities = (portalData, offerType, type, filter = {}) => {
  const types = typesFromType(type);
  const offerTypeEntityIds = portalData.entities[types][`${offerType}Ids`];
  let entities = [];

  for (const id of offerTypeEntityIds) {
    const entity = findPortalDataEntity(portalData, type, id);
    if (entity != null && checkEntityFilter(entity, filter)) {
      entities.push(entity);
    }
  }

  return entities;
};

const findPortalDataEntity = (portalData, type, ids) => {
  try {
    const types = typesFromType(type);
    if (Array.isArray(ids)) {
      let entities = [];
      for (const id of ids) {
        const entity = portalData.entities[types].byId[id];
        if (entity) {
          entities.push(entity);
        }
      }

      return entities;
    } else {
      return portalData.entities[types].byId[ids];
    }
  } catch (e) {
    return undefined;
  }
};

const isPortalDataReady = (portalData, offerType) => {
  try {
    for (const key of Object.keys(portalData.status)) {
      if (
        (offerType === OFFER_TYPES.phoneOffer &&
          (key === "brands" ||
            key === "offerExtraGroups" ||
            key === "offerExtras" ||
            key === "phoneOperatingSystems" ||
            key === "phoneStates" ||
            key === "phoneVariants" ||
            key === "phones" ||
            key === "shops")) ||
        (offerType === OFFER_TYPES.proposition &&
          (key === "brands" ||
            key === "dataSpeedGens" ||
            key === "offerExtraGroups" ||
            key === "offerExtras" ||
            key === "phoneOperatingSystems" ||
            key === "phoneStates" ||
            key === "phoneVariants" ||
            key === "phones" ||
            key === "providers" ||
            key === "shops")) ||
        (offerType === OFFER_TYPES.simOnly &&
          (key === "dataSpeedGens" ||
            key === "offerExtraGroups" ||
            key === "offerExtras" ||
            key === "providers" ||
            key === "shops"))
      )
        if (portalData.status[key].didInvalidate) {
          return false;
        } else if (portalData.status[key].isFetching) {
          return false;
        } else if (portalData.status[key].lastUpdated === 0) {
          return false;
        } else if (portalData.status[key].error != null) {
          return false;
        }
    }

    return true;
  } catch (e) {
    return false;
  }
};

const pickPortalDataEntity = (portalData, type, ids) => {
  try {
    const types = typesFromType(type);
    if (Array.isArray(ids)) {
      for (const id of ids) {
        const entity = portalData.entities[types].byId[id];
        if (entity) {
          return entity;
        }
      }

      return undefined;
    } else {
      return portalData.entities[types].byId[ids];
    }
  } catch (e) {
    return undefined;
  }
};

export {
  findPortalDataEntity,
  filteredEntities,
  isPortalDataReady,
  loadPortalData,
  phoneVariantIdsForPhoneId,
  pickPortalDataEntity
};
